export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-v1-1200-b5a0a6c1138810e9cc174573289401cb.png";